var map = {
	"./clock.png": "0517",
	"./customer-service.png": "7c2d",
	"./fb.png": "99e8",
	"./house.png": "10c1",
	"./mail.png": "fd7a",
	"./phone.png": "3b9b",
	"./tick.png": "e0df",
	"./twitter.png": "9bde",
	"./wa.png": "18d4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0075";